import { Link } from "react-router-dom";
import { Plus } from "lucide-react";
import { motion } from "framer-motion";
import { useCart } from "@/context/CartContext";
import { fcfa, ttc } from "@/lib/format";
import { EASE } from "@/components/motion";

const ProductCard = ({ product, index = 0, noZoom = false }) => {
  const { add } = useCart();

  return (
    <motion.div
      initial={{ opacity: 0, y: 36 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-40px" }}
      transition={{ duration: 0.8, delay: (index % 4) * 0.08, ease: EASE }}
    >
      <Link
        to={`/produit/${product.id}`}
        data-testid={`product-card-${product.id}`}
        className="group block border border-clay bg-cream transition-colors duration-500 hover:border-terracotta"
      >
        <div className="relative aspect-[4/5] overflow-hidden">
          <img
            src={product.image}
            alt={product.name}
            loading="lazy"
            className={`h-full w-full object-cover${noZoom ? "" : " transition-transform duration-700 ease-out group-hover:scale-105"}`}
          />
          {product.badge && (
            <span className="absolute left-4 top-4 bg-terracotta px-3 py-1.5 text-[10px] font-bold uppercase tracking-[0.2em] text-sand">
              {product.badge}
            </span>
          )}
        </div>
        <div className="flex items-end justify-between gap-3 p-5">
          <div>
            <p className="text-[10px] font-semibold uppercase tracking-[0.25em] text-bark/40">{product.category}</p>
            <h3 className="mt-1 font-display text-xl leading-tight text-bark">{product.name}</h3>
            <p className="mt-1.5 text-sm font-bold text-terracotta">{fcfa(ttc(product))}</p>
          </div>
          <button
            data-testid={`quick-add-${product.id}`}
            onClick={(e) => { e.preventDefault(); add(product); }}
            className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full border border-clay text-bark transition-all duration-300 hover:border-terracotta hover:bg-terracotta hover:text-sand"
            aria-label={`Ajouter ${product.name} au panier`}
          >
            <Plus className="h-5 w-5" />
          </button>
        </div>
      </Link>
    </motion.div>
  );
};

export default ProductCard;
